<template>
  <div
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <div ref="element">
      <div v-if="imageIsVisible">
        <!-- src -->
        <img
          v-if="isLoadingSrc && !hovered"
          :src="`${imageProxyUrl}blur:100/plain/${src}`"
          :class="$attrs.class"
        >
        <img
          v-else-if="errorSrc && (!hovered || !hover)"
          :src="`${imageProxyUrl}plain/${logo}`"
          :class="$attrs.class"
        >
        <img
          v-else-if="!hovered || !hover"
          :src="`${imageProxyUrl}plain/${src}`"
          :class="$attrs.class"
        >
        <!-- hover -->
        <img
          v-else-if="isLoadingHover && hovered && hover"
          :src="`${imageProxyUrl}blur:100/plain/${hover}`"
          :class="$attrs.class"
        >
        <img
          v-else-if="hover && hovered"
          :src="`${imageProxyUrl}plain/${hover}`"
          :class="$attrs.class"
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import { inject, ref } from 'vue';
import { useElementVisibility, useImage } from '@vueuse/core';

const props = defineProps({
  src: {
    type: String,
    required: false,
    default: null,
  },
  hover: {
    type: String,
    required: false,
    default: null,
  },
});

const element = ref(null);
const hovered = ref(false);
const logo = inject('logo');
const imageProxyUrl = inject('imageProxyUrl');
const imageIsVisible = useElementVisibility(element);
const { isLoading: isLoadingSrc, error: errorSrc } = props.src
  ? useImage({ src: props.src })
  : { isLoading: ref(false), error: ref(true) };
const { isLoading: isLoadingHover } = props.hover ? useImage({ src: props.hover }) : { isLoading: ref(false) };
</script>
